module.exports = __webpack_public_path__ + "img/translate.16d139ab.png";